import { render, staticRenderFns } from "./ads-and-offers-action-button.vue?vue&type=template&id=39253558&scoped=true&"
import script from "./ads-and-offers-action-button.vue?vue&type=script&lang=js&"
export * from "./ads-and-offers-action-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39253558",
  null
  
)

export default component.exports